import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { makeBoxShadow } from '../../../src/shared/helpers/shadowStyles.helper';

export const getMatchResultCardStyles = (theme: Theme) =>
  StyleSheet.create({
    matchResultCardPressable: {},
    matchResultCardPressablePressed: {
      opacity: 0.85,
    },
    matchResultCardPressableHover: {
      opacity: 0.95,
    },
    matchResultCard: {
      backgroundColor: theme.background.card,
      borderRadius: 16,
      marginHorizontal: 16,
      marginBottom: 12,
      padding: 16,
      borderWidth: 1,
      borderColor: theme.gray[200],
      ...makeBoxShadow({ shadowColor: theme.shadow, shadowOffset: { width: 0, height: 1 }, shadowOpacity: 0.05, shadowRadius: 8 }),
      elevation: 2,
    },
    matchResultCardHeader: {
      marginBottom: 12,
    },
    matchResultCardSpectatorBanner: {
      marginBottom: 12,
      paddingVertical: 8,
      paddingHorizontal: 10,
      borderRadius: 10,
      backgroundColor: theme.gray[100],
      borderWidth: 1,
      borderColor: theme.gray[200],
    },
    matchResultCardSpectatorBannerText: {
      fontSize: 12,
      fontWeight: '500',
      color: theme.gray[600],
      lineHeight: 16,
    },
    matchResultCardTopRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: 12,
    },
    matchResultCardDate: {
      fontSize: 12,
      fontWeight: '500',
      color: theme.gray[500],
      textTransform: 'uppercase',
      letterSpacing: 0.5,
    },
    matchResultCardPill: {
      paddingHorizontal: 10,
      paddingVertical: 4,
      borderRadius: 12,
    },
    matchResultCardPillLive: {
      backgroundColor: theme.success,
    },
    matchResultCardPillActive: {
      backgroundColor: theme.primary + 'CC',
    },
    matchResultCardPillFinished: {
      backgroundColor: theme.gray[300],
    },
    matchResultCardPillCancelled: {
      backgroundColor: theme.gray[200],
    },
    matchResultCardPillText: {
      fontSize: 11,
      fontWeight: '700',
      textTransform: 'uppercase',
      letterSpacing: 0.5,
    },
    matchResultCardPillTextLive: {
      color: theme.textOnStatusBadge,
    },
    matchResultCardPillTextActive: {
      color: theme.textOnStatusBadge,
    },
    matchResultCardPillTextFinished: {
      color: theme.gray[700],
    },
    matchResultCardPillTextCancelled: {
      color: theme.gray[500],
    },
    matchResultCardMiddle: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    matchResultCardPlayer: {
      alignItems: 'center',
      flex: 1,
    },
    matchResultCardAvatar: {
      width: 56,
      height: 56,
      borderRadius: 28,
      marginBottom: 6,
    },
    matchResultCardPlayerName: {
      fontSize: 14,
      fontWeight: '700',
      color: theme.gray[900],
      marginBottom: 2,
    },
    matchResultCardPts: {
      fontSize: 12,
      fontWeight: '600',
      color: theme.gray[600],
    },
    matchResultCardCenter: {
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 16,
      minWidth: 72,
    },
    matchResultCardScore: {
      fontSize: 22,
      fontWeight: '800',
      marginBottom: 2,
      fontFamily: Platform.OS === 'ios' ? 'Menlo' : 'monospace',
      letterSpacing: 0,
    },
    matchResultCardScoreVictory: {
      color: theme.success,
    },
    matchResultCardScoreDefeat: {
      color: theme.error,
    },
    matchResultCardScoreDraw: {
      color: theme.gray[500],
    },
    matchResultCardOutcome: {
      fontSize: 11,
      fontWeight: '600',
      color: theme.gray[500],
      textTransform: 'uppercase',
      letterSpacing: 0.5,
    },
    matchResultCardCoinChip: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 3,
      marginTop: 5,
      paddingHorizontal: 8,
      paddingVertical: 3,
      borderRadius: 10,
      backgroundColor: theme.gray[100],
      borderWidth: 1,
      borderColor: theme.gray[200],
    },
    matchResultCardCoinChipWin: {
      backgroundColor: theme.success + '15',
      borderColor: theme.success + '40',
    },
    matchResultCardCoinChipLoss: {
      backgroundColor: theme.error + '12',
      borderColor: theme.error + '35',
    },
    matchResultCardCoinChipText: {
      fontSize: 13,
      fontWeight: '700',
      color: theme.gray[500],
    },
    matchResultCardCoinChipTextWin: {
      color: theme.success,
    },
    matchResultCardCoinChipTextLoss: {
      color: theme.error,
    },
    matchResultCardCreatedBy: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 4,
      marginTop: 10,
      paddingTop: 8,
      borderTopWidth: 1,
      borderTopColor: theme.gray[100],
    },
    matchResultCardCreatedByText: {
      fontSize: 11,
      color: theme.gray[400],
      fontWeight: '400',
    },
    matchResultCardCreatedByName: {
      fontWeight: '600',
      color: theme.gray[600],
    },
    matchResultCardExpandIcon: {
      alignSelf: 'center',
      marginTop: 8,
      paddingVertical: 4,
    },
    matchResultCardExpandedContent: {
      marginTop: 8,
      paddingTop: 12,
      borderTopWidth: 1,
      borderTopColor: theme.gray[200],
    },
    coinImage: {
      width: 13,
      height: 13,
    },
  });
